'use client'

import * as UI from '../footer.styled'
import {SubscriptionData, SubscriptionSchema} from '../footer.types'
import React, {useState} from 'react'
import {useFormContext} from 'react-hook-form'

import {useMutation} from '@tanstack/react-query'

import {Routes} from '@/src/config/routes'

import {FormProvider} from '@/src/shared/modules/form'

import {useNotification} from '@/src/shared/hooks/useNotification'
import {LicenseAgreement} from '@/src/shared/ui/form/agreement'
import {Label} from '@/src/shared/ui/label'
import {getClient} from '@/src/shared/utils/api-factory'
import {handleMutationException} from '@/src/shared/utils/error'

export const FooterSubscription: React.FC = () => {
  const [subscribed, setSubscribed] = useState(false)

  const handleSubscribe = () => {
    setSubscribed(true)
  }

  return (
    <UI.SubscribeWrapper>
      <UI.SubscribeDescription>
        <p>Статьи о спортивной экипировке и как ее выбрать, технике бега, тренировках.</p>
        <LicenseAgreement btnName="Подписаться" />
      </UI.SubscribeDescription>
      <UI.SubscriptionForm className="dark">
        {!subscribed ? (
          <FormProvider schema={SubscriptionSchema} mode="onSubmit">
            <UI.SubscriptionInput
              id="email-subscribe-input"
              size="large"
              name="email"
              required
              placeholder="Эл. почта"
            />
            <SubscriptionButton onSuccess={handleSubscribe} />
          </FormProvider>
        ) : (
          <Label>Вы успешно подписаны</Label>
        )}
      </UI.SubscriptionForm>
    </UI.SubscribeWrapper>
  )
}

interface SubscriptionButtonProps {
  readonly onSuccess: () => void
}

const SubscriptionButton: React.FC<SubscriptionButtonProps> = ({onSuccess}) => {
  const notifications = useNotification()
  const form = useFormContext<SubscriptionData>()

  const mutation = useMutation({
    mutationFn: async ({email}: SubscriptionData) => {
      const client = getClient()
      const response = await client.post(Routes.webApi.subscribe, {
        data: {email},
      })

      if (response instanceof Response) {
        if (response.status !== 200) {
          throw Error('Что-то пошло не так...')
        }
      }
    },
    async onSuccess() {
      notifications.success('Вы успешно подписались на рассылку, хорошего дня!')
      onSuccess()
    },
    async onError(error) {
      handleMutationException(error)
    },
  })

  const onSubmit = form.handleSubmit(async data => {
    await mutation.mutateAsync(data)
  })

  return (
    <UI.SubscriptionButton type="submit" onClick={onSubmit} loading={mutation.isPending}>
      Подписаться
    </UI.SubscriptionButton>
  )
}
